import { html, nothing } from '@shared/utils/rendering/html';
import LegalEntitiesFilter from './legal-entities-filter';
import PeriodsFilter from './periods-filter';

const OrgFilterGroup = ({ orgFilters, setOrgFilters, setValidEntities, actions }) => {
    const setFieldValue = (value, field) => {
        if (field?.name) {
            setOrgFilters((prev) => ({
                ...prev,
                [field.name]: value,
            }));
        }
    };

    return html`
        <div class="flex-wrap-4 flex-end org-filter-group">
            <div class="flex-item"></div>
            <div class="flex-item"></div>
            <div class="form-group flex-item">
                <${LegalEntitiesFilter}
                    setValidEntities=${setValidEntities}
                    field=${{
                        name: 'legalEntity',
                        value: orgFilters['legalEntity'],
                        setValue: setFieldValue,
                    }}
                />
            </div>
            <div class="flex-item d-flex gap-2">
                <div class="form-group flex-grow-1">
                    <${PeriodsFilter}
                        field=${{
                            name: 'period',
                            value: orgFilters['period'],
                            setValue: setFieldValue,
                        }}
                    />
                </div>
                ${actions ? html`<div class="org-filter-actions">${actions}</div>` : nothing}
            </div>
        </div>
    `;
};

export default OrgFilterGroup;
